import "@components/Front/custom.scss";
import "@components/Front/front.scss";
import PrivateRoute from "@components/PrivateRoute";
import DynamicSeoPage from "@components/fetchSeoMeta";
import TopBar from "@components/topbar/TopBar";
import * as Sentry from "@sentry/react";
// import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Provider } from "react-redux";
import {
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "./ErrorBoundary";
import ChatbotWidget from "./_components/ChatbotWidget";
import { persistor, store } from "./_helpers/store";
import "./index.css";
import AboutPage from "./pages/About/AboutPage";
import BecomeOnInstructor from "./pages/Become On Instructor/BecomOnInstructor";
import BlogPage from "./pages/Blogs/BlogPage";
import CareersPage from "./pages/Careers/CareersPage";
import Details from "./pages/Careers/Details";
import Categories from "./pages/Categories/Categories";
import CategoryDetails from "./pages/Categories/CategoryDetails";
import SubCategories from "./pages/Categories/SubCategories";
import BundleDetail from "./pages/Courses/CourseDetails/BundleDetail";
import CourseDetail from "./pages/Courses/CourseDetails/CourseDetail";
import BundlesContainer from "./pages/Courses/CoursesContainer/BundlesContainer";
import CoursesContainer from "./pages/Courses/CoursesContainer/CoursesContainer";
import Main from "./pages/Dashboard/Main";
import Cart from "./pages/Dashboard/ShoppingCart/Cart/Cart";
import { Checkout } from "./pages/Dashboard/ShoppingCart/Checkout/Checkout";
import EnterprisePage from "./pages/Enterprise/EnterprisePage";
import EventsPage from "./pages/Events/EventsPage";
import Faq from "./pages/Faq/Faq";
import ForBusiness from "./pages/ForBusiness/ForBusiness";
import HomePage from "./pages/Home/HomePage";
import LearningHubIndex from "./pages/LearningHub";
import ForgotPassword from "./pages/Login/ForgotPassword";
import LoginPage from "./pages/Login/LoginPage";
import SignupPage from "./pages/Login/SignupPage";
import UpdatePassword from "./pages/Login/UpdatePassword";
import WelcomeSmik from "./pages/Login/welcomeUser/WelcomeUser";
import Accessibility from "./pages/Other/Accessibility";
import Business from "./pages/Other/Business";
import ProgrammerStandOut from "./pages/Other/ProgramerStandOut";
import Contact from "./pages/Other/Contact";
import Cookies from "./pages/Other/Cookie/Cookie";
import CookiePolicy from "./pages/Other/CookiePolicy";
import CorprateTraining from "./pages/Other/CorprateTraining";
import CustomAlert from "./pages/Other/CustomAlert/CustomAlert";
import FeaturesPage from "./pages/Other/FeaturesPage";
import Footer from "./pages/Other/Footer";
import GrievanceSection from "./pages/Other/Grievance";
import Langusity from "./pages/Other/Langusity/Langusity";
import MatureContentPage from "./pages/Other/MatureContent";
import Page404 from "./pages/Other/Page404";
import Partners from "./pages/Other/Partners";
import PostSecondary from "./pages/Other/PostSecondary";
import PricingPage from "./pages/Other/PricingPage";
import PrivacyPage from "./pages/Other/Privacy";
import Refund_Policy from "./pages/Other/Refund_Policy";
import { ScrollRestoration } from "./pages/Other/ScrollRestoration";
import SearchPannel from "./pages/Other/Search/SearchPannel";
import SearchPosts from "./pages/Other/SearchComponent";
import Sitemap from "./pages/Other/Sitemap";
import Skillup from "./pages/Other/Skillup";
import TermsPage from "./pages/Other/Terms";
import TrademarkPolicy from "./pages/Other/TrademarkPolicy";
import DemoPage from "./pages/Other/demo";
import Smikrecruit from "./pages/Other/smikrecruit/smikrecruit";
import PressPage from "./pages/Press/PressPage";
import Programs from "./pages/Program/ProgramDetails";
import ReviewsPage from "./pages/Program/Reviews/Reviews";
import TeachingPage from "./pages/Teacher/TeachingPage";
import AlumniSpeakMain from "./pages/AlumniSpeak";
import RssFeed from "./pages/RssFeed";
import Resources from "./pages/Resources";
import Guaranteed from "./pages/Guaranteed";
import JobsPage from "./pages/Jobs/JobsPage";
import OffersPage from "./pages/Offers/OffersPage";
const { REACT_APP_LOGIN_API_BASEURL } = process.env;
function App() {
  const [initialized, setInitialized] = useState(false);
  const [manageCookie, setManageCookie] = useState(false);
  const [manageAnimation, setManageAnimation] = useState(true);
  const getCookie = localStorage.getItem("cookie");
  const { i18n } = useTranslation();
  const [token, setToken] = useState();
 
  useEffect(() => {
    if (getCookie === "false") {
      setManageCookie(false);
    } else {
      setTimeout(() => {
        handleCookie();
        setManageCookie(true);
      }, 15000);
    }
  }, []);

  useEffect(() => {
    if (!initialized) {
      localStorage.setItem(
        "language",
        localStorage.getItem("language") || "en"
      );
      i18n.changeLanguage(localStorage.getItem("language") || "en");
      setInitialized(true);
    }
  }, [i18n, initialized]);

  const handleAnimation = () => {
    setManageAnimation(true);
  };

  const handleCookie = () => {
    setManageAnimation(false);
  };

  return (
    <div>
    <Provider store={store}>
      {/* <TawkMessengerReact
        propertyId={process.env.REACT_APP_TAWK_PROPERTY_KEY}
        widgetId={process.env.REACT_APP_TAWK_WIDGET_KEY}
      /> */}
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <ErrorBoundary>
            <Routes>
              <Route
                element={
                  <div className="front-panel">
                    <DynamicSeoPage />
                    <TopBar />
                    <ScrollRestoration />
                    <Outlet />
                    <Footer />
                    {manageCookie && (
                      <Cookies
                        manageAnimation={manageAnimation}
                        handleAnimation={handleAnimation}
                      />
                    )}
                    <CustomAlert />
                  </div>
                }
              >
                <Route path="/" element={<HomePage />} />
                <Route path="/categories/:slug" element={<CourseDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/careers/detail/:id" element={<Details />} />
                <Route path="/business" element={<EnterprisePage />} />
                <Route
                  path="/pricing"
                  element={
                    <div className="front-panel">
                      <PricingPage />
                    </div>
                  }
                />
                <Route path="/demo" element={<DemoPage />} />
                <Route path="/languisity" element={<Langusity />} />
                <Route path="/features" element={<FeaturesPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/press" element={<PressPage />} />
                <Route path="/careers" element={<CareersPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/sitemap" element={<Sitemap />} />
                <Route path="/accessibility" element={<Accessibility />} />
                <Route path="/welcomesmik" element={<WelcomeSmik />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/teachers" element={<TeachingPage />} />
                <Route path="/forget-password" element={<ForgotPassword />} />
                <Route path="/reset" element={<UpdatePassword />} />
                <Route path="/register" element={<SignupPage />} />
                <Route path="/terms-and-conditions" element={<TermsPage />} />
                <Route
                  path="/mature-guidelines"
                  element={<MatureContentPage />}
                />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/cookies" element={<CookiePolicy />} />
                <Route path="/trademarkpolicy" element={<TrademarkPolicy />} />
                <Route path="/postsecondary" element={<PostSecondary />} />
                <Route path="/training" element={<CorprateTraining />} />
                <Route path="/bundles" element={<BundlesContainer />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/checkout" element={<Checkout/>} />
                <Route path="/courses" element={<CoursesContainer />} />
                {/* <Route path="/search" element={<SearchPage />} /> */}
                <Route path="/partners" element={<Partners />} />
                <Route path="/skillup" element={<Skillup />} />
                <Route
                  path="/grievance-redressal"
                  element={<GrievanceSection />}
                />
                {/* <Route path="/dashboard/wishlist" element={<Wishlist />} /> */}
                <Route path="/bundle/:id" element={<BundleDetail />} />
                <Route
                  path="/courses/:subCategory/:type?"
                  element={<SubCategories />}
                />
                {/* <Route element={<Page404 />} />{" "} */}
                <Route path="*" element={<Page404 />} />
                {/* Catch-all route for 404 errors */}
                <Route
                  path="/login"
                  element={<LoginPage setToken={setToken} />}
                />
                <Route path="/userReview" element={<ReviewsPage />} />
                <Route path="/:slug/userReview" element={<ReviewsPage />} />
                <Route path="/:slug" element={<Programs />} />
                <Route path="/forbusiness" element={<ForBusiness />} />
                <Route path="/review" element={<AlumniSpeakMain />} />
                <Route path="/feed" element={<RssFeed/>}/>   
                <Route path="/resourse" element={<Resources/>}/>             
                <Route
                  path="/learning-hub-plus"
                  element={<LearningHubIndex />}
                />
                <Route
                  path="/becomeaninstructor"
                  element={<BecomeOnInstructor />}
                />
                <Route path="/refund-policy" element={<Refund_Policy />} />
                <Route path="/searchposts" element={<SearchPosts />} />
                <Route path="/smikrecruit" element={<Smikrecruit />} />
                <Route path="/search-new" element={<SearchPannel />} />
                <Route path="/guaranteed" element={<Guaranteed />} />
                <Route path="/business-page" element={<Business />} />
                <Route path="/programmer-stand-out" element={<ProgrammerStandOut />} />
                <Route path="/jobs" element={<JobsPage />} />
                <Route path="/special-offers" element={<OffersPage />} />
                {/* <Route path="/smikrecruit" element={<Careers />} /> */}
                <Route
                  path="/categories/:slug/:id"
                  element={<CategoryDetails />}
                />
                
              </Route>
              <Route element={<PrivateRoute />}>
                <Route path="/dashboard/*" element={<Main />} />
              </Route>
            </Routes>
          </ErrorBoundary>
        </Router>
      </PersistGate>
    </Provider>
    <ChatbotWidget/>
    <Toaster position="top-right" />
    <ToastContainer position="top-right" autoClose={3000} theme="light" />
    </div>
  );
}

export default Sentry.withProfiler(App);
